import dayjs from 'lib/dayjs';
import { toNumber } from 'lodash-es';

export function formatRelativeTime(timestamp: number | string, t: (key: string) => string): string {
  const now = dayjs();
  const target = dayjs(toNumber(timestamp));
  const diffMinutes = now.diff(target, 'minute');

  if (diffMinutes < 0) {
    return '-';
  }

  if (diffMinutes < 60) {
    return `${diffMinutes}${t('common.time.minuteShort')}`;
  }

  const diffHours = now.diff(target, 'hour');
  if (diffHours < 24) {
    return `${diffHours}${t('common.time.hourShort')}`;
  }

  return `${now.diff(target, 'day')}${t('common.time.dayShort')}`;
}
